import { Mqtt_Topics_userManagementChanges } from "../RAWMap.Models/Api.js";
import { singleton } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { Msg } from "./UserTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_userManagementChanges(uid)), (Item) => (new Msg(19, [Item]))];
}

